<template>
  <h2 class="m-0 p-0 font-normal text-xl md:text-3xl"><slot /></h2>
</template>
<script setup lang="ts"></script>
